// extracted by mini-css-extract-plugin
module.exports = {"container":"Step_container__1JYco","title":"Step_title__rd29A","number":"Step_number__1jrv3"};